import React from 'react'

const Alp = () => {
    return (
        <div className='container'>
            <h1>Program for patterns of alphabets</h1>
 <p>Write a program in C++ to display the pattern like pyramid using the alphabet.</p>
   <div className='output'>
      Input: N=5 <br />
      output: <pre>{`
         A                                                              
      A B A                                                            
    A B C B A                                                          
  A B C D C B A                                                        
A B C D E D C B A `}</pre>
   </div>
   <div 
    class="containers"> <br/>
    <span class="token macro property"><span class="library">#</span><span class="library">include</span> <span class="plain">&lt;iostream&gt;</span></span>  <br/>
    using namespace std<span class="plain">;</span> <br/>
     <br/>
    <span class="keywords">int</span> <span class="token function">main</span><span class="plain">(</span><span class="plain">)</span> <br/>
    <span class="plain">&#123;</span> <br/>
        <span class="keywords">int</span> i<span class="plain">,</span> j<span class="plain">;</span> <br/>
        <span class="keywords">char</span> alph <span class="token operator">=</span> <span class="plain">'A'</span><span class="plain">;</span> <br/>
        <span class="keywords">int</span> n<span class="plain">,</span> blk<span class="plain">;</span> <br/>
        <span class="keywords">int</span> ctr <span class="token operator">=</span> <span class="token number">1</span><span class="plain">;</span> <br/>
        cout <span class="token operator">&lt;&lt;</span> <span class="plain">"\n\n Display the pattern like pyramid using the alphabet:\n"</span><span class="plain">;</span> <br/>
        cout <span class="token operator">&lt;&lt;</span> <span class="plain">"---------------------------------------------------------\n"</span><span class="plain">;</span> <br/>
        cout <span class="token operator">&lt;&lt;</span> <span class="plain">" Input the number of Letters (less than 26) in the Pyramid: "</span><span class="plain">;</span> <br/>
        cin <span class="token operator">&gt;&gt;</span> n<span class="plain">;</span> <br/>
        <span class="keywords">for</span> <span class="plain">(</span>i <span class="token operator">=</span> <span class="token number">1</span><span class="plain">;</span> i <span class="token operator">&lt;=</span> n<span class="plain">;</span> i<span class="token operator">++</span><span class="plain">)</span> <span class="plain">&#123;</span> <br/>
            <span class="keywords">for</span> <span class="plain">(</span>blk <span class="token operator">=</span> <span class="token number">1</span><span class="plain">;</span> blk <span class="token operator">&lt;=</span> n <span class="token operator">-</span> i<span class="plain">;</span> blk<span class="token operator">++</span><span class="plain">)</span> <br/>
                cout <span class="token operator">&lt;&lt;</span> <span class="plain">"  "</span><span class="plain">;</span> <br/>
            <span class="keywords">for</span> <span class="plain">(</span>j <span class="token operator">=</span> <span class="token number">0</span><span class="plain">;</span> j <span class="token operator">&lt;=</span> <span class="plain">(</span>ctr <span class="token operator">/</span> <span class="token number">2</span><span class="plain">)</span><span class="plain">;</span> j<span class="token operator">++</span><span class="plain">)</span>  <br/>
            <span class="plain">&#123;</span> <br/>
                cout <span class="token operator">&lt;&lt;</span> alph<span class="token operator">++</span> <span class="token operator">&lt;&lt;</span> <span class="plain">" "</span><span class="plain">;</span> <br/>
            <span class="plain">&#125;</span> <br/>
            alph <span class="token operator">=</span> alph <span class="token operator">-</span> <span class="token number">2</span><span class="plain">;</span> <br/>
            <span class="keywords">for</span> <span class="plain">(</span>j <span class="token operator">=</span> <span class="token number">0</span><span class="plain">;</span> j <span class="token operator">&lt;</span> <span class="plain">(</span>ctr <span class="token operator">/</span> <span class="token number">2</span><span class="plain">)</span><span class="plain">;</span> j<span class="token operator">++</span><span class="plain">)</span>  <br/>
            <span class="plain">&#123;</span> <br/>
                cout <span class="token operator">&lt;&lt;</span> alph<span class="token operator">--</span> <span class="token operator">&lt;&lt;</span> <span class="plain">" "</span><span class="plain">;</span> <br/>
            <span class="plain">&#125;</span> <br/>
            ctr <span class="token operator">=</span> ctr <span class="token operator">+</span> <span class="token number">2</span><span class="plain">;</span> <br/>
            alph <span class="token operator">=</span> <span class="plain">'A'</span><span class="plain">;</span> <br/>
            cout <span class="token operator">&lt;&lt;</span> endl<span class="plain">;</span> <br/>
        <span class="plain">&#125;</span> <br/>
    <span class="plain">&#125;</span> <br/>
    <span aria-hidden="true" class="line-numbers-rows"><span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span></span></div> <br/>
      <div className='output'>
          <p><strong>Output:</strong></p>
          
          Display the pattern like pyramid using the alphabet:   <br />                
          ---------------------------------------------------------   <br />           
           Input the number of Letters (less than 26) in the Pyramid: 5 <br />
           <pre>{ `       
                   A                                                              
                A B A                                                            
              A B C B A                                                          
            A B C D C B A                                                        
          A B C D E D C B A `}</pre> 
          
      </div>
      <hr />
      <div className='output'>
      Input: N=5 <br />
      output: <pre>{`
       A B C D E 
       B C D E
       C D E
       D E
       E `}</pre>
   </div>
   <div class="containers">
    <div class="line number1 index0 alt2"><code class="comment">//  Triangular</code></div> <br/>
    <div class="line number2 index1 alt1"><code class="comment">// patterns of alphabets</code></div> <br/>
    <div class="line number3 index2 alt2"><code class="library">#include &lt;bits/stdc++.h&gt;</code></div> <br/>
    <div class="line number4 index3 alt1"><code class="keywords">using</code> <code
            class="keywords">namespace</code> <code class="plain">std;</code></div> <br/>

    <div class="line number6 index5 alt1"><code class="library">int</code> <code class="plain">main()</code></div> <br/>
    <div class="line number7 index6 alt2"><code class="plain">&#123;</code></div> <br/>
    <div class="line number8 index7 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="library">int</code> <code class="plain">i, j, n = 5;</code></div> <br/>
    <div class="line number9 index8 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keywords">for</code> <code class="plain">(i = 1; i &lt;= n; i++)</code></div> <br/>
    <div class="line number10 index9 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#123;</code></div> <br/>
    <div class="line number11 index10 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keywords">for</code> <code class="plain">(j = i; j &lt;= n; j++)</code></div> <br/>
    <div class="line number12 index11 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#123;</code>
    </div> <br/>
    <div class="line number13 index12 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">cout &lt;&lt; (</code><code class="library">char</code><code class="plain">)(</code><code
            class="string">'A'</code> <code class="plain">- 1 + j) &lt;&lt; </code><code class="string">" "</code><code
            class="plain">;</code></div> <br/>
    <div class="line number14 index13 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#125;</code>
    </div> <br/>
    <div class="line number15 index14 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">cout &lt;&lt; endl;</code></div> <br/>
    <div class="line number16 index15 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#125;</code></div> <br/>
    <div class="line number17 index16 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keywords">return</code> <code class="plain">0;</code></div> <br/>
    <div class="line number18 index17 alt1"><code class="plain">&#125;</code></div> <br/>

   
</div> 
<div className='output'>
     
     <p><strong>output:</strong> </p>
       <pre>{`
       A B C D E 
       B C D E
       C D E
       D E
       E `}</pre>
   </div>
   <hr />
   <div className='output'>
      Input: N=5 <br />
      output: <pre>{`
       E
       D E
       C D E
       B C D E
       A B C D E`}</pre>
   </div>
   <div class="containers"> 
    <div class="line number1 index0 alt2"><code class="library">#include &lt;iostream&gt;</code></div> <br/>
    <div class="line number2 index1 alt1"><code class="keywords">using</code> <code
            class="keywords">namespace</code> <code class="plain">std;</code></div> <br/>
    <div class="line number4 index3 alt1"><code class="library">int</code> <code class="plain">main()</code></div> <br/>
    <div class="line number5 index4 alt2"><code class="plain">&#123;</code></div> <br/>
    <div class="line number6 index5 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="library">int</code> <code class="plain">i, j, n = 5;</code></div> <br/>
    <div class="line number7 index6 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keywords">for</code> <code class="plain">(i = n; i &gt;= 1; i--) &#123;</code></div> <br/>
    <div class="line number8 index7 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keywords">for</code> <code class="plain">(j = i; j &lt;= n; j++) &#123;</code></div> <br/>
    <div class="line number9 index8 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">cout &lt;&lt; (</code><code class="library">char</code><code class="plain">)(</code><code
            class="string">'A'</code> <code class="plain">+ j - 1) &lt;&lt; </code><code class="string">" "</code><code
            class="plain">;</code></div> <br/>
    <div class="line number10 index9 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#125;</code>
    </div> <br/>
    <div class="line number11 index10 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">cout &lt;&lt; endl;</code></div> <br/>
    <div class="line number12 index11 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#125;</code></div> <br/>
    <div class="line number13 index12 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keywords">return</code> <code class="plain">0;</code></div> <br/>
    <div class="line number14 index13 alt1"><code class="plain">&#125;</code></div> <br/>
    <div class="line number15 index14 alt2">&nbsp;</div> <br/>
    </div> <br/>
        </div>
    )
}

export default Alp
